import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { NotificationStateService } from '../../services/notification-state.service';
import {
  AvailableComplianceNotifications,
  AvailableTrainingNotifications,
} from '../../+state/notification.models';

@Component({
  selector: 'cp-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  public topPriorityComplianceNotification$ =
    this._notificationService.getTopPriorityComplianceNotification();

  public topPriorityTrainingNotification$ =
    this._notificationService.getTopPriorityTrainingNotification();

  public complianceNotificationTypes = AvailableComplianceNotifications;
  public trainingNotificationTypes = AvailableTrainingNotifications;

  constructor(private _notificationService: NotificationStateService) {}
}
